var $82fcf897ec5f2bf0$exports = {};
$82fcf897ec5f2bf0$exports = {
    "breadcrumbs": `\u{130}\xe7erik haritalar\u{131}`
};


export {$82fcf897ec5f2bf0$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
